import { PropsWithChildren } from 'react';

import { Navigate } from 'components/router';

import { isDisconnectedForMonth } from './utils';

import { useCluster } from '@cast/shared-cluster-context-data-access';

type Props = PropsWithChildren<{
  checks?: {
    isDisconnected?: boolean;
    isManaged?: boolean;
  };
}>;

export const WhenClusterIsNotArchived = ({ children, checks }: Props) => {
  const { cluster } = useCluster();

  if (checks?.isManaged) {
    if (cluster && !cluster.credentialsId) {
      return <Navigate to="./dashboard" />;
    }
  }

  if (checks?.isDisconnected) {
    if (cluster && isDisconnectedForMonth(cluster)) {
      return <Navigate to="./dashboard" />;
    }
  }

  return children;
};
